// Datos de Originación. UN endpoint: `GET /backoffice/origination/analytics` del wizard.
//
// No toma rango. Los tres chips de ventana (7 / 30 / 90 días) vienen en la MISMA respuesta,
// calculados de la misma lectura, así que mover el chip no vuelve a pegarle a la API.
import { useQuery } from '@tanstack/react-query';
import { originationApi } from '@/api/services/retail-wizard/backoffice';

export const ORIGINATION_QUERY_KEY = ['credit', 'origination', 'analytics'] as const;

/** `enabled` apaga la lectura cuando el rol no tiene el permiso: un 403 seguro no se pide. */
export function useOriginationAnalytics(enabled = true) {
    return useQuery({
        queryKey: ORIGINATION_QUERY_KEY,
        queryFn: () => originationApi.getOriginationAnalytics(),
        staleTime: 5 * 60_000,
        enabled,
    });
}
